import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import useTranslation from "../../../hooks/useTranslation";

const OutlinedButton = ({
  title,
  onClick,
  initialState,
  faIcon,
  iconPosition,
  icon,
  className,
}) => {
  const T = useTranslation();
  const [active, setActive] = useState(initialState);

  const handlerOnClick = () => {
    if (onClick) onClick();
  };

  useEffect(() => {
    setActive(initialState);
  }, [initialState]);

  return (
    <div
      onClick={handlerOnClick}
      style={{ borderWidth: 2 }}
      className={`
                border border-[#228C80]
                text-[#228C80]
                cursor-pointer 
                text-center  
                rounded-[8px] 
                w-[280px] 
                h-[60px] 
                flex flex-col items-center 
                justify-center
                bg-transparent
                hover:bg-[#E6F4F3] 
                transition
                ${className}
            `}
    >
      <div
        style={{ flexDirection: iconPosition || "row" }}
        className={`flex items-center gap-2 justify-center w-full px-4`}
      >
        
        <div className="text-[16px] font-[600] flex items-center">
          <span>{T(title)}</span>
        </div>
        {icon && (
          <div className="flex items-center justify-center w-[40px] h-[40px]">
            <img src={icon} alt="icon" />
          </div>
        )}{faIcon && <FontAwesomeIcon icon={faIcon} className="text-[18px]" />}
      </div>
    </div>
  );
};

export default OutlinedButton;
